// 案件头部组件国际化配置 - 英文
export default {
  // Meta information labels
  creator: "Creator",
  createTime: "Create Time",
  updateTime: "Update Time",

  // Buttons and actions
  addressMonitor: "Address Monitor",
  edit: "Edit",
  delete: "Delete",

  // Balance board
  balanceBoard: {
    title: "Balance Board - Total Asset Balance",
    tooltipTitle:
      "You can right-click on the address in the canvas to add it to the balance board",
    tooltipContent:
      "The total asset balance of the address is calculated by converting all main coins and tokens held by the address into USDT based on the currency value recorded in this system. The currency value is affected by various factors and changes. The total asset data is for reference only. The system currently supports",
    supportedCurrencies: "317 currencies",
    detail: "Details >",
    loadingText: "Loading...",
  },

  // Error messages
  errors: {
    loadAssetFailed: "Failed to load asset data, please try again later",
    caseIdMissing: "caseInfo.id does not exist, unable to get asset details",
  },
};
